/* eslint-disable no-console */
// Punto único para registrar errores técnicos. El aviso al usuario lo da
// toastDispacher; esto solo deja el detalle para depurar. Si se agrega un
// servicio de monitoreo, se conecta aquí. ESLint prohíbe `console.*` en el resto.
const logger = {
  error: (...args) => console.error(...args),
  warn: (...args) => console.warn(...args),
};

export default logger;
